import { useEffect } from 'react';
import { connect } from 'redux-bundler-react';
import Tooltip from '../tooltip/tooltip';
import { Label, Textarea } from '@trussworks/react-uswds';
import { Controller, useFormContext } from 'react-hook-form';
import Creatable from 'react-select/creatable';

import { customSelectStyles, customSelectStylesNonRequired } from '@forms/input-forms/helpers';
import genericSecondaryModal from '@forms/components/modals/genericSecondaryModal';
import { useModal } from '@stores';
import FileDownloadList from '../file-download-list/FileDownloadList';

import { isValidText } from '@src/utils/helpers';
import { ErrorMessages } from '@src/utils/enums';

import classNames from 'classnames';

const CreatableSelectInput = connect(
  ({
    disabled,
    fileDownload,
    handleChange,
    handleBlur,
    label,
    loading,
    multi,
    name,
    options,
    placeholder,
    readOnly,
    required,
    tooltip,
    tooltipClickable,
  }) => {
    const {
      control,
      watch,
      setValue,
      formState: { errors },
      getValues,
    } = useFormContext();
    const { openSecondaryModal } = useModal();

    const inputError = errors[name];

    const errorStyle = required ? customSelectStyles : customSelectStylesNonRequired;

    const input = watch(name);

    const selectedValues = getValues(name) || [];
    const displayValue = selectedValues.map((option) => option?.label).join(', ');

    useEffect(() => {
      if (input && input.length > 0) {
        input.forEach((val) => {
          if (val?.value && typeof val.value === 'string' && val?.label && typeof val.label === 'string') {
            if (isValidText(val.value) && isValidText(val.label)) {
              return;
            } else {
              // Optionally handle invalid input here, such as warning the user
              const msg = ErrorMessages.InvalidCharacters;
              openSecondaryModal(genericSecondaryModal, { title: 'Invalid Characters', msg: msg });
              setValue(
                name,
                input.filter((item) => item.value !== val.value)
              );
            }
          }
        });
      }
    }, [input, name, setValue, openSecondaryModal]);

    const labelStyles = classNames({
      required: required,
      optional: !required,
    });

    return (
      <>
        <Label className={labelStyles} htmlFor={name}>
          <span id={`${name}_label`}>{label}</span>
          {tooltip && <Tooltip name={name} header={label} content={tooltip} clickable={tooltipClickable} />}
        </Label>
        {fileDownload?.length > 0 && <FileDownloadList files={fileDownload} />}
        {readOnly ? (
          <Textarea className={'read-only-multiselect'} id={name} name={name} readOnly={true} value={displayValue} />
        ) : (
          <Controller
            control={control}
            name={name}
            render={({ field: { onChange, onBlur, value, name, ref } }) => (
              <Creatable
                inputId={name}
                styles={inputError ? errorStyle : ''}
                required={required}
                isDisabled={disabled}
                options={options}
                isLoading={loading}
                placeholder={placeholder}
                onChange={(e) => {
                  onChange(e);
                  handleChange && handleChange(e);
                }}
                isMulti={multi}
                onBlur={(e) => {
                  onBlur(e);
                  handleBlur && handleBlur(e);
                }}
                value={value}
                name={name}
                ref={ref}
              />
            )}
          />
        )}
      </>
    );
  }
);
export default CreatableSelectInput;
